import { CustomRule, RequiredRule, Validator } from 'devextreme-react/validator';
import { DateBox } from 'devextreme-react/date-box';
import { useContext } from 'react';
import { Field, Panel } from '../../../../layouts';
import { AR, OrderStatus } from '../../../../types/enums';
import { PurchaseOrderContext } from '../context/PurchaseOrderContext';
import { formatShortDate } from '../../../../utils/date-utils';
import { RecurrencePatternTypes } from '../../cfi-routing/types/RecurrencePatternTypes';
import { RecurrenceRangeTypes } from '../../cfi-routing/types/RecurrenceRangeTypes';
import { validateDeliveryDate } from '../../../cfi/material-order/functions/deliveryDate';
import { DeliveryDateSettings } from '../../../cfi/material-order/types/DeliveryDateSettings';

export default function ValidateDeliveryDatePanel() {

	const { order, modifyOrder } = useContext(PurchaseOrderContext);

	const isOrderReadonly = order.details.orderStatusID === OrderStatus.Closed ||
		order.details.orderStatusID === OrderStatus.Cancelled;

	const isReadOnly = !order.details.activeARs.includes(AR.PODistributorToValidateDeliveryDate) || isOrderReadonly;
	const isRequired = !isReadOnly;

	const isDateDisabled = (data: { date: Date }) => {
		const schedule = order.details.products?.length === 1 ? order.details.products[0].deliveryDateSettings : order.details.cfiRouting;
		if (!schedule) {
			const day = data.date.getDay();
			return day === 0 || day === 6;
		}
		return !validateDeliveryDate(data.date, schedule as DeliveryDateSettings);
	};

	return (
		<Panel header={'Dates'} >
			<Field label="Requested Delivery Date">
				{formatShortDate(order.details.requestedDeliveryDate)}
			</Field>
			<Field label="Validated Delivery Date" >
				<DateBox value={order.details.validatedDeliveryDate}
					onValueChanged={(e) => modifyOrder({ ...order.details, validatedDeliveryDate: e.value })}
					readOnly={isReadOnly}
					className={isRequired ? 'required' : ''}
					disabledDates={isDateDisabled}
				>
					<Validator>
						{
							isRequired && order.modified &&
							<RequiredRule message={'Validated Delivery Date is required'} />
						}
						<CustomRule
							validationCallback={(data) => {
								if (order.details.requestedDeliveryDate && data.value)
									return new Date(data.value) >= order.details.requestedDeliveryDate;
								else
									return true;
							}}
							message="Validated Delivery Date must be greater or equal than Requested Delivery Date"
						/>
					</Validator>
				</DateBox>
			</Field>
		</Panel>
	);
}
